t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <h2>{{ $t('rooms.question') }}</h2>
      <div class="rooms">
        <CountIconInput
          class="room"
          v-for="(room, i) in roomsData"
          :key="i"
          :question="room.question"
          :icon="room.icon"
          :counter.sync="rooms[room.variable]"
        ></CountIconInput>
      </div>
      <one-button
        type="primary"
        class="next-btn"
        :class="{ disabled: !Object.keys(rooms).find(name => rooms[name] > 0) }"
        @click.native="next()"
      >
        {{ $t('next') }}
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";
  import CountIconInput from "../../components/CountIconInput";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getPrevStepUrl, getStepIndex, redirectToUnselectedStepIfAny} from "@/utils/steps.js";
  import {goToNextStep} from "../../utils/steps";

  export default {
  name: "Rooms",
  components: { CalculatorHeading, CountIconInput },
  data() {
    return {
      step: getStepIndex("rooms"),
      getPrevStepUrl: getPrevStepUrl,
      rooms: this.$store.state.data.rooms,
      roomsData: [
        { question: this.$t("rooms.kitchen"), icon: "sink", variable: "kitchen" },
        { question: this.$t("rooms.dining"), icon: "utensils", variable: "dining" },
        { question: this.$t("rooms.living"), icon: "couch", variable: "living" },
        { question: this.$t("rooms.bathroom"), icon: "bath", variable: "bathroom" },
        { question: this.$t("rooms.bedroom"), icon: "bed", variable: "bedroom" },
        { question: this.$t("rooms.hallway"), icon: "shoe-prints", variable: "hallway" },
        { question: this.$t("rooms.staircase"), icon: "level-up-alt", variable: "staircase" },
        { question: this.$t("rooms.wellness"), icon: "spa", variable: "wellness" },
        { question: this.$t("rooms.gym"), icon: "dumbbell", variable: "gym" },
        { question: this.$t("rooms.basement"), icon: "archive", variable: "basement" },
        { question: this.$t("rooms.office"), icon: "laptop", variable: "office" },
        { question: this.$t("rooms.storage"), icon: "box", variable: "storage" },
        { question: this.$t("rooms.garage"), icon: "car", variable: "garage" },
        { question: this.$t("rooms.other"), icon: "shapes", variable: "other" }
      ]
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  watch: {
    rooms: {
      handler() {
        this.updateRooms(this.rooms);
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(["updateRooms"]),
    next() {
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
  justify-content: space-between;
}
.rooms {
  padding-top: 10px;
  max-width: 962px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.room {
  padding: 0 20px 0 20px;
}

@media only screen and (max-width: 800px) {
  .rooms {
    justify-content: center;
  }
}
</style>
